module.exports = __webpack_public_path__ + "img/shiyanyi.d4b95ae3.jpg";